/* eslint-disable import/no-unresolved */
import BaseElement from 'base-element'
import { css, html } from 'lit-all'
import * as paths from 'lib-paths'
import styles from 'lib-styles'
/* eslint-disable import/no-unresolved */

class HHToggle extends BaseElement {
  static get properties() {
    return {
      checked: { type: Boolean, reflect: true },
      loading: { type: Boolean, reflect: true },
      error: { type: Boolean, reflect: true },
      type: { type: String },
      customerId: { type: String },
    }
  }

  constructor() {
    super()

    this.error = false
    this.loading = false
    this.checked = this.getAttribute('checked') === ''
    this.phone = this.getAttribute('phone')

    this.paths = {
      email: { enable: '/email/enable', disable: '/email/disable' },
      sms: { enable: '/sms/enable', disable: '/sms/disable' },
    }
  }

  apiFetch = async (url, config) => {
    const slSwitch = this.shadowRoot.querySelector('sl-switch')

    this.error = false
    this.loading = true
    slSwitch.disabled = true

    fetch(url, config)
      .then((res) => {
        console.log(res.json())
      })
      .catch((err) => {
        console.error(err)
        this.error = true
      })
      .finally(() => {
        if (!this.error) {
          this.checked = !this.checked
        }

        slSwitch.checked = this.checked
        this.loading = false
        slSwitch.disabled = false
      })
  }

  async _fetchData() {
    const config = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ customerId: this.customerId }),
    }

    const url = `${__THEME_GLOBALS__.accountPreferencesBaseUrl}/${
      this.paths[this.type][this.checked ? 'enable' : 'disable']
    }`

    this.apiFetch(url, config)
  }

  _handleInputChange() {
    this._fetchData()
  }

  _renderIcons() {
    if (this.loading || this.error) {
      return html`
        <div class="account-communication-preferences__form-loader">
          ${this.loading ? paths.loadingSpinner : paths.error}
          <p class="p message">
            ${this.loading ? 'Saving...' : 'Error: Could not update'}
          </p>
        </div>
      `
    }
  }

  render() {
    return html`
      <div>
        <div
          class="account-preference-toggle account-communication-preferences__form"
        >
          <p class="p">Off</p>

          <sl-switch
            @sl-change=${this._handleInputChange}
            ${this.checked ? checked : ''}
          ></sl-switch>

          <p class="p">On</p>
        </div>

        ${this._renderIcons()}
      </div>
    `
  }

  static styles = [
    styles.toggleComponent,
    styles.spinnerAnimation,
    css`
      :host {
        display: block;
      }

      :host([checked]) sl-switch[checked]::part(control) {
        background-color: #25b900;
        transform: translateX(40px);
      }

      sl-switch::part(base) {
        width: 80px;
        height: 40px;
        border: 1px solid #ababab;
        border-radius: 20px;
        padding: 2px;
        position: relative;
      }

      sl-switch::part(control),
      sl-switch::part(control--checked) {
        width: 34px;
        height: 34px;
        border-radius: 50%;
        position: absolute;
      }

      sl-switch::part(control) {
        background-color: #ababab;
        transform: translateX(0);
        transition:
          transform 0.25s ease-in-out,
          background-color 0.25s ease-in-out;
      }

      .account-preference-toggle {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-top: 20px;
        gap: 10px;
      }

      .account-preference-toggle p.p {
        color: #3b3a3a;
        transition: color 0.25s ease-in-out;
      }

      @media screen and (min-width: 992px) {
        .account-preference-toggle {
          margin-top: 0;
          justify-content: flex-end;
        }
      }
    `,
  ]
}

customElements.define('hh-communication-preferences-toggle', HHToggle)
